'use client'

import React, { useEffect, useState } from 'react'
import Input from '../ui/Input';
import { IoMdSearch } from "react-icons/io";
import { useRouter } from 'next/navigation';

const isBrowser = typeof window !== 'undefined'

export default function ContentModalSearch() {

    const route = useRouter();
    const [search, setSearch] = useState({key:'', type:''});

    useEffect(() => {
        if (isBrowser) {
            import("preline/preline").then((module) => {
                // Once loaded, call autoInit after a short delay
                setTimeout(() => {
                    window.HSStaticMethods.autoInit();
                }, 100);
            });
        }
    }, []);

    const handelInput = (e) => {
        setSearch({ ...search, [e.target.name]: e.target.value })
    }

    const submitForm = async e => {
        e.preventDefault();
        route.push('/search/'+search.key);
    }

    return (
        <div id="hs-search-modal" className="hs-overlay hidden size-full fixed top-0 start-0 z-[80] overflow-x-hidden overflow-y-auto pointer-events-none">
            <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto min-h-[calc(100%-3.5rem)] flex items-center">
                <div className="pointer-events-auto w-full flex flex-col shadow-sm dark:bg-gray-800 dark:shadow-slate-700/[.7]">
                    <form onSubmit={submitForm}>
                        <div className="relative flex">
                            <Input type="text" onChange={handelInput} id="hs-inline-leading-pricing-select-label" name="key" className="py-3 h-14 px-4 w-full ps-9 pe-20 block disabled:opacity-50 disabled:pointer-events-none border-0" placeholder="search for ..." />
                            <div className="absolute inset-y-0 start-0 flex items-center pointer-events-none z-20 ps-3">
                                <span className="text-custom-orange-900 text-xl"><IoMdSearch /></span>
                            </div>
                            {/* <div className="flex items-center text-gray-500 pe-px">
                                <select className="py-3 px-4 h-14 pe-9 cursor-pointer block w-ful border-0 border-l text-sm disabled:opacity-50 disabled:pointer-events-none focus:ring-0">
                                    <option>Select type</option>
                                    <option defaultValue={'tours'}>Tours</option>
                                    <option defaultValue={'activities'}>Activities</option>
                                </select>
                            </div> */}
                            <button type='submit' className='h-14 px-6 text-white bg-custom-green transition-colors delay-75'>Search</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    )
}
